module.exports = __webpack_public_path__ + "hinted-OpenSansLight-Italic.502bfd5172c93c94baec.ttf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSansLight-Italic.ttf
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSansLight-Italic.ttf
// module chunks = 1